import classes from './ProductsSummary.module.css';

const ProductsSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>Discover Zimbabwean Culinary Heritage</h2>
      <p>
        Choose your preferred traditional delights from our diverse array of
        Zimbabwean culinary treasures and savor an authentic taste of Zimbabwe
        for your next meal at home.
      </p>
      <p>
        Join us in celebrating the heart and soul of Zimbabwean cuisine. Get
        ready to embark on a gastronomic adventure that connects you with the
        roots of Zimbabwean food, right from the comfort of your home.
      </p>
    </section>
  );
};

export default ProductsSummary;
